// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609090634/js/" + chunkId + "." + {"44":"d87e58f1","225":"6a07e568","481":"e03e6946","486":"bcd0be98","770":"dbcfe074"}[chunkId] + ".0.5031520887228429.chunk.js";
};